import { Component, ChangeDetectorRef, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GlobalDialogService, DialogType } from '../../_service/global-dialog.service';
import { DialogModule } from 'primeng/dialog';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ButtonModule } from 'primeng/button';
import { CommonModule } from '@angular/common';
import { Observable } from 'rxjs';
import { ViewChild } from '@angular/core';
import { Dialog } from 'primeng/dialog';


@Component({
    selector: 'app-global-dialog',
    standalone: true,
    templateUrl: './global-dialog.component.html',
    imports: [DialogModule, ProgressSpinnerModule, ButtonModule, CommonModule]
})
export class GlobalDialogComponent implements OnInit {
    DialogType = DialogType;
    visible$: Observable<boolean>;
    @ViewChild('globalDialog', { static: false }) myDialog?: Dialog;


    constructor(public gDS: GlobalDialogService, private router: Router) {
        this.visible$ = this.gDS.visible$;
    }

    ngOnInit() {
        this.gDS.notifyReady(); // Signal that component is ready to receive dialogs
    }

    close() {
        this.gDS.hide();
        if (this.myDialog) {
            this.myDialog.maskVisible = false;
            this.myDialog.visible = false;
        }
    }
}
